import { Route } from 'react-router-dom';
import CompanySitePage from '../../pages/CompanySite';
import ForgotPassword from '../../pages/ForgotPassword';
import Invite from '../../pages/Invite';
import Login from '../../pages/Login';
import Register from '../../pages/Register';
import ResetPassword from '../../pages/ResetPassword';

export const PUBLIC_ROUTES = [
  {
    path: '/c/:companyId',
    component: CompanySitePage,
    exact: true,
  },
  {
    path: '/login',
    component: Login,
    exact: true,
  },
  {
    path: '/invite',
    component: Invite,
    exact: true,
  },
  {
    path: '/register',
    component: Register,
    exact: true,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    exact: true,
  },
  {
    path: '/resetPassword',
    component: ResetPassword,
    exact: true,
  },
];

const publicRoutes = () =>
  PUBLIC_ROUTES.map((route) => <Route {...route} key={route.path} />);

export default publicRoutes;
